
export default {
  path: 'organisations',
  component: () => import(/* webpackChunkName: "admin" */ '@/components/wrapper.vue'),
  children: [
    {
      path: '/',
      name: 'admin.organisations',
      component: () => import(/* webpackChunkName: "admin" */ './organisationList.vue'),
    }, {
      path: ':organisationId',
      name: 'admin.organisation.view',
      component: () => import(/* webpackChunkName: "admin" */ './organisation.vue'),
    },
    {
      path: 'add',
      name: 'admin.organisation.add',
      component: () => import(/* webpackChunkName: "admin" */ './addOrganisation.vue'),
    }
  ],
};
